
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { FontIcon } from "office-ui-fabric-react";

import ToolbarLink from '../common/ToolbarLink';


const classNames = mergeStyleSets({
    root: {
        width: '100%',
    },

    label: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },

    val: {
        display: 'flex',
        justifyContent: 'flex-end',
        minWidth: '200px'
    }
})

const OperationItem = ({
    operationItem,
    toolbarItems
}) => {

    return (
        <Stack horizontal className={classNames.root}>
            <Stack.Item grow align="center">
                <Stack tokens={{childrenGap: '1em'}} horizontal className={classNames.label}>
                    <FontIcon className={classNames.icon} iconName="LocationDot"></FontIcon>
                    <Stack.Item>{operationItem.title}</Stack.Item>
                    <Stack.Item grow className={classNames.val}>
                        {new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(operationItem.price)}
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <ToolbarLink
                    items={toolbarItems}
                />
            </Stack.Item>
        </Stack>
    );
}

export default OperationItem;
